import React from 'react';

import PulseMonitor from './PulseMonitor.js';
import { arterialPressure, arterialVitals } from './pulseModel.js';

const COLOR = [255, 25, 25];
// Fixed pressure scale: 55–130 mmHg spans y=130–25. Higher pressure plots upward.
const sample = (seconds) => 130 - ((arterialPressure(seconds) - 55) / 75) * 105;

const renderPressure = ({ systolic, diastolic, map }) => (
  <div className="arterial-readout">
    <div className="monitor-readout-label pressure-heading">
      <span>ART</span>
      <span className="pressure-unit">mmHg</span>
    </div>
    <span id="arterial-pressure-value" className="pressure-systolic-diastolic">
      {Math.round(systolic)}/{Math.round(diastolic)}
    </span>
    <div className="pressure-mean-row">
      <span className="pressure-mean-label">MAP</span>
      <span id="mabp-value" className="pressure-mean">
        ({Math.round(map)})
      </span>
    </div>
  </div>
);

const MAPSketch = () => (
  <PulseMonitor
    label="ART"
    className="mabp"
    color={COLOR}
    sample={sample}
    readout={arterialVitals}
    initialValue={arterialVitals(0)}
    renderReadout={renderPressure}
  />
);

export default MAPSketch;
